// based on https://www.npmjs.com/package/react-screen-orientation
import * as React from "react";

export namespace Orientation {
  export type OrientationKind = "portrait" | "landscape";

  type Props = {
    alwaysRender: boolean;
    className?: string;
    orientation: OrientationKind;
  };

  export class Orientation extends React.Component<Props, undefined> {
    render() {
      const { orientation, children, className } = this.props;

      return (
        <div
          className={`${className} react-orientation react-orientation--${orientation}`}
        >
          {children}
        </div>
      );
    }
  }

  const noop = () => false;

  interface IWindowScreen {
    lockOrientationUniversal: any;
    mozLockOrientation: any;
    orientation: {
      addEventListener: () => void;
      lock: any;
      type: string;
    };
  }

  (window.screen as any).lockOrientationUniversal =
    window.screen.lockOrientation ||
    (window.screen as any).mozLockOrientation ||
    window.screen.msLockOrientation;

  const windowScreen = (window.screen as any) as IWindowScreen;

  const lock = orientation => {
    const screen = windowScreen;
    if (screen.orientation && typeof screen.orientation.lock === "function") {
      return screen.orientation.lock(orientation);
    } else if (screen.lockOrientationUniversal) {
      return new Promise((resolve, reject) => {
        if (screen.lockOrientationUniversal(orientation)) {
          resolve();
        } else {
          reject();
        }
      });
    } else {
      return new Promise((_resolve, reject) => reject());
    }
  };

  class DeviceOrientationProps {
    className?: string;
    lockOrientation?: string;
    onLockOrientation?: (succeeded: boolean) => void;
    onOrientationChange?: (
      orientation: string,
      type: string,
      angle: string | number
    ) => void;
  }

  export class DeviceOrientation extends React.Component<
    DeviceOrientationProps,
    {
      orientation: string | null;
      type: string | null;
      angle: string | number | null;
    }
  > {
    constructor(props) {
      super(props);
      this.lockOrientation(props);
      this.onOrientationChange = this.onOrientationChange.bind(this);

      this.state = {
        orientation: null,
        type: null,
        angle: null
      };
    }

    componentWillMount() {
      this.onOrientationChange(null);
    }

    componentDidMount() {
      if (windowScreen.orientation && "onchange" in windowScreen.orientation) {
        const orientation = windowScreen.orientation as any;
        orientation.addEventListener("change", this.onOrientationChange);
      } else if ("onorientationchange" in window) {
        window.addEventListener("orientationchange", this.onOrientationChange);
      }
    }

    componentWillUnmount() {
      if (windowScreen.orientation && "onchange" in windowScreen.orientation) {
        const orientation = windowScreen.orientation as any;
        orientation.removeEventListener("change", this.onOrientationChange);
      } else if ("onorientationchange" in window) {
        window.removeEventListener(
          "orientationchange",
          this.onOrientationChange
        );
      }
    }

    onOrientationChange(_event) {
      const onOrientationChange = this.props.onOrientationChange || noop;
      let orientation: OrientationKind = "portrait";
      let type = "primary";
      let angle: string | number = 0;
      if (window.orientation) {
        angle = window.orientation;

        if (isFinite(angle as number)) {
          orientation =
            Math.abs(angle as number) === 90 ? "landscape" : "portrait";
        } else {
          orientation = "landscape";
        }
      }

      if (windowScreen.orientation) {
        let orientationText = "";
        [orientationText, type] = windowScreen.orientation.type.split("-");

        switch (orientationText) {
          case "landscape":
            orientation = "landscape";
            break;
          case "portrait":
            orientation = "portrait";
            break;
          default:
            orientation = "landscape";
        }

        angle = orientation;
      }
      this.setState({
        orientation,
        type,
        angle
      });
      onOrientationChange(orientation, type, angle);
    }

    lockOrientation({ lockOrientation }) {
      if (typeof lockOrientation !== "string") {
        return;
      }
      const onLockOrientation = this.props.onLockOrientation || noop;
      return lock(lockOrientation)
        .then(function() {
          onLockOrientation(true);
        })
        .catch(function() {
          onLockOrientation(false);
        });
    }

    render() {
      const { children, className } = this.props;
      const { orientation } = this.state;

      return (
        <div className={`${className}`}>
          {React.Children.map(children, child => {
            const { props } = child as any;

            if (props) {
              const childOrientation = props.orientation as OrientationKind;
              if (props.alwaysRender || childOrientation === orientation) {
                return child;
              }
            }
          })}
        </div>
      );
    }
  }

  // https://developer.mozilla.org/en-US/docs/Web/API/screen/lockOrientation
  //   const LOCK_ORIENTATIONS = [
  //     "portrait-primary",
  //     "portrait-secondary",
  //     "landscape-primary",
  //     "landscape-secondary",
  //     "portrait",
  //     "landscape",
  //     "default"
  //   ];
}



// WEBPACK FOOTER //
// ./components/Orientation.tsx